import { render, staticRenderFns } from "./ConfigMenuEdit.vue?vue&type=template&id=241be829"
import script from "./ConfigMenuEdit.vue?vue&type=script&lang=js"
export * from "./ConfigMenuEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports